// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Lock from "@insite/mobius/Icons/Lock";
import Users from "@insite/mobius/Icons/Users";
import { wishListSharingStatusStyles } from "@vanmeter/Overrides/Components/WishListSharingStatus";
import { fontConfig } from "@vanmeter/XDL/constants";
import IconNotificationInfo from "@vanmeter/XDL/Icons/IconNotificationInfo";
import { color } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

wishListSharingStatusStyles.privateTooltip = {
    iconProps: {
        src: IconNotificationInfo,
        size: 12,
        color: "primary",
        css: css`
            &:hover {
                color: ${color("common.ui15")};
            }
        `,
    },
    extendedStyles: {
        triggerWrapper: {
            css: css`
                margin: 0;
            `,
        },
    },
} as any;

wishListSharingStatusStyles.statusText = {
    ...fontConfig.xSmallSingleLine,
    css: css`
        display: flex;
        align-items: center;
        gap: 6px;
    `,
};

wishListSharingStatusStyles.sharedIcon = {
    src: Users,
    size: 15,
    color: "primary",
    css: css`
        margin-right: 5px;
        &:hover {
            color: ${color("common.ui15")};
        }
    `,
};

wishListSharingStatusStyles.autogeneratedIcon = {
    src: Lock,
    size: 12,
};



